export default "__VITE_ASSET__BbKkxwxl__"